<template>
  <form novalidate @submit.prevent="submit">
    <v-card :loading="saving" :disabled="saving">
      <v-card-text class="pa-6">
        <h4 class="subtitle-2 text-uppercase black--text mb-7 d-flex align-center">
          <span>Manage Account</span>
          <v-spacer></v-spacer>
          <v-btn
            @click="onDelete"
            depressed
            small
            class="red lighten-2 white--text"
            :disabled="editIndex === -1"
          >Remove</v-btn>
        </h4>
        <v-combobox
          v-model="formData.title"
          :items="accountTypes"
          item-text="value"
          return-object
          v-validate="'required|min:2'"
          :error-messages="errors.collect('accountName')"
          :label="dictionary.attributes.accountName"
          data-vv-name="accountName"
          prepend-icon="mdi-account-box-outline"
          required
        ></v-combobox>
        <v-text-field
          v-model="formData.email"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
          :label="dictionary.attributes.email"
          data-vv-name="email"
          prepend-icon="mdi-at"
          required
        ></v-text-field>
        <v-text-field
          v-model="formData.uri"
          :error-messages="errors.collect('uri')"
          :label="dictionary.attributes.uri"
          data-vv-name="uri"
          prepend-icon="mdi-link"
          required
        ></v-text-field>
        <!-- <pre>{{ extraData }}</pre> -->
        <div class="mt-5 d-flex">
          <v-spacer></v-spacer>
          <v-btn depressed text type="reset" @click="close">Cancel</v-btn>
          <v-btn depressed color="accent" class="ml-2" type="submit">Save</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </form>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import types from '@/store/types';
import { FB_ACCOUNT_SETTINGS } from '@/store/constants/accounts.constants';

export default {
  name: 'project-accounts-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    extraData: {
      default() {
        return {};
      },
    },
    editIndex: {
      type: Number,
      default() {
        return -1;
      },
    },
    formData: {
      type: Object,
      default() {
        return {
          date: new Date().toISOString().slice(0, 10),
        };
      },
    },
  },

  data: () => ({
    today: new Date().toISOString().slice(0, 10),
    dateMenu: false,
    saving: false,
    dictionary: {
      attributes: {
        accountName: 'Acccount Name',
        uri: 'URI',
        email: 'Email Address',
      },
    },
  }),

  computed: {
    ...mapState(['accountTypes']),
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    ...mapActions('db', {
      updateAccount: types.UPDATE_PROJECT,
    }),
    getPayload() {
      const payload = {
        ...this.extraData,
      };
      if (!payload.accounts) {
        payload.accounts = [];
      }

      const newData = {
        ...this.formData,
      };

      const { title } = newData;

      if (typeof title === 'string') {
        newData.title = {
          ...FB_ACCOUNT_SETTINGS,
          id: title.toLowerCase().split(' ').join(''),
          value: title,
        };
      }

      if (this.editIndex === -1 || payload.accounts.length === 0) {
        payload.accounts.unshift(newData);
      } else {
        payload.accounts[this.editIndex] = {
          ...newData,
        };
      }
      return payload;
    },
    saveAccount(newPayload) {
      if (!newPayload) {
        return;
      }
      const payload = {
        ...newPayload,
      };

      this.saving = true;
      this.updateAccount(payload)
        .then(() => {
          this.$emit('save', payload);
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true;
          const payload = this.getPayload();
          this.saving = false;
          this.saveAccount(payload);
        }
      });
    },
    close() {
      this.$emit('close');
    },
    clear() {
      this.$validator.reset();
    },
    onDelete() {
      const payload = this.getPayload();
      payload.accounts = payload.accounts.filter(
        (i, index) => index !== this.editIndex,
      );
      this.saveAccount(payload);
    },
  },
};
</script>
